import React from "react";
import ReactDOM from "react-dom";
import { inject } from "@vercel/analytics";
import "./index.css";
import App from "./App";

// Use the framework-independent API: Analytics v2’s React component targets React 18+.
inject({}, process.env.REACT_APP_VERCEL_OBSERVABILITY_CLIENT_CONFIG);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
